// Isolated, TEMPORARY local onboarding/subscription state for FioNova Web.
// NOT connected to production auth, database, or Stripe. localStorage only.
// This exists so routing can architecturally bypass completed onboarding for a
// returning/subscribed user once the post-paywall app is built in a later phase.

const KEYS = {
  account: "fionova_local_account",       // { name, email } — demo only, never real
  onboarding: "fionova_onboarding_complete",
  subscribed: "fionova_subscribed",       // reserved for future post-paywall routing
  setup: "fionova_setup_selections",
};

const read = (k, fallback) => {
  try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : fallback; }
  catch { return fallback; }
};
const write = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} };

export const onboardingState = {
  getAccount: () => read(KEYS.account, null),
  setAccount: (acct) => write(KEYS.account, acct),
  isOnboardingComplete: () => read(KEYS.onboarding, false) === true,
  completeOnboarding: () => write(KEYS.onboarding, true),
  isSubscribed: () => read(KEYS.subscribed, false) === true,
  setSubscribed: (v) => write(KEYS.subscribed, v === true),
  saveSetup: (sel) => write(KEYS.setup, sel),
  getSetup: () => read(KEYS.setup, {}),
};
